export const LOAD_STATES = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error"
};
